const defaultState = {
  windowLevelData: {
    1: { description: 'Soft tissue', window: '550', level: '40' },
    2: { description: 'Lung', window: '400', level: '60' },
    3: { description: 'Liver', window: '600', level: '300' },
    4: { description: 'Bone', window: '1500', level: '300' },
    5: { description: 'Brain', window: '80', level: '40' },
    6: { description: 'Trest', window: '400', level: '40' },
    7: { description: '', window: '1500', level: '-400' },
    8: { description: '', window: '', level: '' },
    9: { description: '', window: '', level: '' },
    10: { description: '', window: '', level: '' },
  },
  generalPreferences: {
    // language: 'en-US'
  },
};

const preferences = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_USER_PREFERENCES': {
      return Object.assign({}, state, action.state);
    }
    default:
      return state;
  }
};

export { defaultState };
export default preferences;
